import * as actions from "./actionsTypes";

const initialData = {
  loaderCategoriaDesempenio: false,
  categoriaDesempenio: null,
  categoriaDesempenioFalla: null,
  saveLoaderCategoriaDesempenio: false,
  categoriaDesempenioFormError:null
};

export default function CategoriaDesempenioReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_CATEGORIA_DESEMPENIO:
      return { ...state, loaderCategoriaDesempenio: action.payload };

    case actions.GET_CATEGORIA_DESEMPENIO:
      return { ...state, categoriaDesempenio: action.payload };

    case actions.CATEGORIA_DESEMPENIO_FALLA:
      return { ...state, categoriaDesempenioFalla: action.payload };

    case actions.SAVE_LOADER_CATEGORIA_DESEMPENIO:
      return { ...state, saveLoaderCategoriaDesempenio: action.payload };

    case actions.FORM_CATEGORIA_DESEMPENIO_FAIL:
      return { ...state, categoriaDesempenioFormError: action.payload };
      
    default:
      return state;
  }
}
